import { productSupportsOwners } from 'src/financial/financial-data/financial-item/forms/common/OwnersEditor';

/**
 * Cashflow items are held by their owners the way financial items are, each owner with a share of
 * the item's whole amount, kept in the field named here. They record no joint answer of their own:
 * several owners are what make one joint.
 */
const CASHFLOW_AMOUNT_FIELDS = new Map([
  ['Income', 'amount_pre_tax'],
  ['Expenditure', 'amount'],
  ['LifeEvent', 'cost'],
]);

export const isCashflowItem = (entityType: string): boolean =>
  CASHFLOW_AMOUNT_FIELDS.has(entityType);

export const cashflowAmountField = (entityType: string): string | undefined =>
  CASHFLOW_AMOUNT_FIELDS.get(entityType);

/** Whether saving a detection of this type writes the owners the review sends. */
export const detectionSavesOwners = (entityType: string): boolean =>
  productSupportsOwners(entityType) || isCashflowItem(entityType);
